<template>
  <div class="background" @click="clickBack()">
    <v-dialog v-model="dialog" light persistent max-width="400" class="elevation-5">
      <view-access-control
        @start="start($event)"
        @cancel="cancel()"
      ></view-access-control>
    </v-dialog>

    <div v-if="dialogCamera">
      <v-dialog v-model="dialogCamera" max-width="700">
        <v-card class="glass-card">
          <v-col>
            <qrcode-stream @decode="onDecode" @init="onInit" />
          </v-col>
        </v-card>
      </v-dialog>
    </div>

    <div class="main-container">
      <!-- Input con efecto glass -->
      <div class="glass-input-container">
        <v-text-field 
          class="input-control"
          number
          color="white"
          autofocus
          ref="textcontrol"
          @keyup.enter="access()"
          dark   
          maxlength="32"
          v-model="document"
          @click:append-outer="clickCamera()"
          hide-details
          dense 
          block
          outlined
          append-outer-icon="mdi-camera"
          :clearable="true"
          placeholder="Ingrese documento o escanee QR"
        ></v-text-field>
      </div>

      <!-- Mensaje superior en móvil -->
      <v-col v-if="person != null" style="padding-top: 0px; padding-bottom: 0px">
        <transition name="fade-slide">
          <v-card 
            v-if="person.MahMessage" 
            class="d-flex d-sm-none justify-center glass-message-card"
            rounded="lg"
            style="margin-bottom: 10px;"
            :style="`background: ${getGlassColor(person.color)}`"
          >
            <p class="message-text-mobile">
              <v-row justify="center">
                <b>{{ person.MahMessage }}</b>
              </v-row>
            </p>
          </v-card>
        </transition>

        <!-- Tarjeta principal con efecto glass -->
        <v-col style="padding: 0px">
          <transition name="scale-fade">
            <v-card class="glass-main-card" elevation="0">
              <!-- Header -->
              <div class="glass-header">
                <v-row>
                  <v-col class="d-flex justify-center">
                    <h1 class="header-title d-flex d-sm-none">
                      {{ pv.DedAbbreviation }}
                    </h1>
                    <h1 class="header-title d-none d-sm-flex">
                      {{ pv.DedDescription }}
                    </h1>
                  </v-col>
                </v-row>
              </div>

              <!-- Contenido principal -->
              <v-col class="card-content">
                <v-row>
                  <!-- Imagen - Desktop -->
                  <v-col
                    class="d-none d-sm-flex"
                    lg="4" 
                    md="4"  
                    style="padding-top: 0px; padding-bottom: 0px"
                  >
                    <v-col style="padding: 10px">
                      <transition name="image-fade">
                        <div class="image-container">
                          <v-img
                            v-if="image == ''"
                            height="440"
                            src="./../../../public/static/User.png"
                            class="person-image"
                          ></v-img>
                          <v-img 
                            v-else 
                            height="440" 
                            :src="image"
                            class="person-image"
                          ></v-img>
                        </div>
                      </transition>
                    </v-col>
                  </v-col>

                  <!-- Información de la persona -->
                  <v-col class="info-section" lg="8">
                    <transition name="fade-slide" mode="out-in">
                      <div :key="person.NtpName">
                        <!-- Nombre completo -->
                        <h1
                          v-if="person.NtpName"
                          class="person-name d-none d-sm-flex"
                        >
                          <v-row justify="center">
                            {{
                              person.NtpPaternalSurname +
                              " " +
                              person.NtpMaternalSurname +
                              " " +
                              person.NtpName
                            }}
                          </v-row>
                        </h1>
                        <h1
                          v-if="person.NtpName"
                          class="person-name-mobile d-flex d-sm-none"
                        >
                          {{
                            person.NtpPaternalSurname +
                            " " +
                            person.NtpMaternalSurname +
                            " " +
                            person.NtpName
                          }}
                        </h1>

                        <h1
                          v-else
                          class="default-title"
                        >
                          CONTROL DE ACCESO
                        </h1>

                        <!-- Número de documento -->
                        <h1 class="document-number d-none d-sm-flex">
                          <v-col class="d-flex justify-center" style="padding:0px">
                            {{ person.PrsDocumentNumber }}
                          </v-col>
                        </h1>
                        <h1 class="document-number-mobile d-sm-none">
                          {{ person.PrsDocumentNumber }}
                        </h1>

                        <!-- Puesto -->
                        <h1 class="position-name d-none d-sm-flex">
                          <v-col class="d-flex justify-center" style="padding:0px">
                            {{ person.PstName }}
                          </v-col>
                        </h1>
                        <h1 class="position-name-mobile d-sm-none">
                          {{ person.PstName }}
                        </h1>

                        <!-- Área -->
                        <h1
                          v-if="person.AreName"
                          class="area-name d-none d-sm-flex"
                        >
                          <v-col class="d-flex justify-center" style="padding:0px">
                            {{ person.AreName }}
                          </v-col>
                        </h1>
                        <h1
                          v-if="person.AreName"
                          class="area-name-mobile d-sm-none"
                        >
                          {{ person.AreName }}
                        </h1>

                        <!-- Imagen - Mobile -->
                        <v-row justify="center" class="d-sm-none mobile-image-row">
                          <transition name="image-fade">
                            <div class="mobile-image-container">
                              <v-img
                                v-if="image == ''"
                                min-width="250"
                                height="250"
                                src="./../../../public/static/User.png"
                                class="person-image-mobile"
                              ></v-img>
                              <v-img
                                v-else
                                width="250"
                                min-width="250"
                                height="250"
                                :src="image"
                                class="person-image-mobile"
                              ></v-img>
                            </div>
                          </transition>
                        </v-row>
                      </div>
                    </transition>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
          </transition>
        </v-col>

        <!-- Mensaje inferior - Desktop -->
        <v-col style="padding-left:0px;padding-right:0px;">
          <v-row class="d-none d-sm-flex">
            <v-col style="padding-top: 10px">
              <transition name="fade-slide">
                <v-card 
                  v-if="person.MahMessage"
                  rounded="lg" 
                  class="glass-message-card"
                  :style="`background: ${getGlassColor(person.color)}`"
                >
                  <p class="message-text-desktop">
                    <v-row justify="center">
                      <b>{{ person.MahMessage }}</b>
                    </v-row>
                  </p>
                </v-card>
              </transition>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import ControlAccessService from "./../../services/Management/ControlAccess";
import HelperService from "./../../services/HelperService";
import ViewAccessControl from "./AccessControl";

export default {
  name: "TimeRealReserve",
  components: { ViewAccessControl, QrcodeStream },
  props: {},

  data: () => ({
    dialogCamera: false,
    pv: null,
    image: "",
    document: "",
    dialog: true,
    timeRefresh: 0,
    pv: {},
    person: {
      NtpFullName: "CONTROL DE ACCESO",
      PstName: "",
      PrsDocumentNumber: "",
      color: "white",
    },
  }),
  
  methods: {
    getGlassColor(color) {
      const colorMap = {
        'success': 'rgba(76, 175, 80)',
        'warning': 'rgba(255, 193, 7)',
        'red': 'rgba(244, 67, 54)',
        'white': 'rgba(255, 255, 255)'
      };
      return colorMap[color] || 'rgba(255, 255, 255)';
    },

    onDecode(result) {
      this.document = result;
      this.access();
      this.dialogCamera = false;
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        console.log(error);
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    },

    clickCamera() {
      this.dialogCamera = true;
    },

    clickBack() {
      this.$refs.textcontrol.focus();
    },

    start(pv) {
      if (pv != null) {
        this.$fun.fullScreen();
        this.pv = pv;
        this.person.PstName = this.$moment().format("DD/MM/YYYY");
        this.dialog = false;
        this.$nextTick().then(() => {
          this.$refs.textcontrol.focus();
        });
      }
    },

    cancel() {
      this.$router.go(-1);
    },

    access() {
      if (this.document.length > 3) {
        console.log(this.document);
        ControlAccessService.personaccess(
          this.document,
          this.$fun.getUserID(),
          this.pv.DedValue,
          1
        ).then((r) => {
          this.document = "";
          this.person = r.data;
          if (this.person.TypeError == 0) this.person.color = "success";
          else if (this.person.TypeError == 2) {
            this.person.color = "warning";
            this.$fun.soundAlert();
          } else if (this.person.TypeError == 1) {
            this.person.color = "red";
            this.$fun.soundAlert();
          }
          
          this.clickBack();
          
          HelperService.getPhotoWorkerBase64(
            r.data.PrsDocumentNumber,
            this.$fun.getUserID()
          ).then((rsp) => {
            if (rsp.status === 200 && rsp.data) {
              this.image = 'data:image/jpg;base64,' + rsp.data;
            } else {
              console.error("No se pudo cargar la imagen");
            }
          }).catch((error) => {
            console.error("Error al obtener la imagen:", error);
            this.image = ""; 
          });
        }).catch((error) => {
          this.document = "";
        });
      }
    },
  },

  created() {
    let timerId = setInterval(() => {
      this.timeRefresh = this.timeRefresh + 1000;
      if (this.timeRefresh >= localStorage.getItem("TimeToken") / 2) {
        $("body").trigger("mousemove");
        clearInterval(timerId);
      }
    }, 1000);
  },
};
</script>

<style scoped>
/* Fondo principal */
.background {
  background-repeat: no-repeat;
  background-size: cover !important;
  background-attachment: fixed !important;
  background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.1)
    ),
    url("./../../assets/SunshineWallpaper.jpg");
  min-height: 100vh;
  padding: 20px;
}

/* Contenedor principal */
.main-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* Efecto Glassmorphism para el input */
.glass-input-container {
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.glass-input-container:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.input-control >>> input {
  font-size: 24px !important;
  color: white !important;
  font-weight: 500;
}

.input-control >>> .v-input__icon--append-outer {
  color: white !important;
  font-size: 24px !important;
}

.input-control >>> fieldset {
  border-color: rgba(255, 255, 255, 0.3) !important;
  border-width: 2px;
  border: none;
}

/* Tarjeta principal con glassmorphism */
.glass-main-card {
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);
  background: rgba(255, 255, 255, 0.12) !important;
  border-radius: 24px !important;
  border: 1px solid rgba(255, 255, 255, 0.25);
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1),
              0 0 1px rgba(255, 255, 255, 0.5) inset;
  min-height: 440px;
}

/* Header de la tarjeta */
.glass-header {
  background: linear-gradient(135deg, 
    rgba(0, 0, 0, 0.7) 0%, 
    rgba(0, 0, 0, 0.5) 100%);
  backdrop-filter: blur(10px);
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-title {
  font-size: 36px !important;
  color: white;
  font-weight: 600;
  letter-spacing: 1px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  margin: 0;
}

/* Contenido de la tarjeta */
.card-content {
  padding: 24px;
}

/* Sección de información */
.info-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
}

/* Estilos de texto */
.person-name {
  font-size: 52px !important;
  line-height: 1.1;
  color: white;
  font-weight: 700;
  text-align: center;
  margin-bottom: 16px;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
}

.person-name-mobile {
  font-size: 28px !important;
  color: white;
  font-weight: 700;
  text-align: center;
  margin-bottom: 12px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
}

.default-title {
  font-size: 60px !important;
  color: white;
  font-weight: 700;
  text-align: center;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
}

.document-number {
  font-size: 38px !important;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
  padding: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.document-number-mobile {
  font-size: 22px !important;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
  text-align: center;
  margin-bottom: 12px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.position-name {
  font-size: 48px !important;
  color: #FFD54F;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 16px;
  padding: 0;
  text-shadow: 0 3px 12px rgba(255, 193, 7, 0.4);
}

.position-name-mobile {
  font-size: 24px !important;
  color: #FFD54F;
  font-weight: 700;
  text-align: center;
  margin-bottom: 12px;
  text-shadow: 0 2px 10px rgba(255, 193, 7, 0.4);
}

.area-name {
  font-size: 32px !important;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-align: center;
  padding: 0;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.area-name-mobile {
  font-size: 20px !important;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-align: center;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Contenedores de imagen */
.image-container,
.mobile-image-container {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.person-image {
  border-radius: 16px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.person-image-mobile {
  border-radius: 16px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.mobile-image-row {
  margin-top: 16px;
}

/* Tarjeta de mensaje con glassmorphism */
.glass-message-card {
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.glass-message-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
}

.message-text-desktop {
  padding: 16px;
  color: white;
  font-size: 42px;
  font-weight: 700;
  text-align: center;
  margin: 0;
  text-shadow: 0 3px 12px rgba(0, 0, 0, 0.4);
}

.message-text-mobile {
  padding: 12px;
  color: white;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
}

/* Efecto glass para el dialog de cámara */
.glass-card {
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  background: rgba(255, 255, 255, 0.15) !important;
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* Animaciones */
@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleFade {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes imageFade {
  from {
    opacity: 0;
    filter: blur(10px);
  }
  to {
    opacity: 1;
    filter: blur(0);
  }
}

/* Transiciones Vue */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.scale-fade-enter-active,
.scale-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.scale-fade-enter,
.scale-fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.image-fade-enter-active,
.image-fade-leave-active {
  transition: all 0.5s ease;
}

.image-fade-enter,
.image-fade-leave-to {
  opacity: 0;
  filter: blur(10px);
}

/* Responsive */
@media (max-width: 600px) {
  .background {
    padding: 12px;
  }

  .glass-input-container {
    padding: 12px;
    margin-bottom: 12px;
  }

  .input-control >>> input {
    font-size: 24px !important;
  }

  .card-content {
    padding: 16px;
  }
}
</style>